/**
 * Created by hy on 2019-6-24.
 */

export default{
  playerShow: false, // 是否显示播放器
  currBag: {}, // 讲解专辑信息
  playing: false, // 播放状态 Boolean
  playList: [], // 当前播放专辑列表 Array
  currVoice: {}, // 当前播放音频信息
  currIndex: -1, // 当前播放歌曲索引
  currUrl: '', // 当前播放歌曲地址
  videoTimer: null, //音频计时器
  Audio1: null, //音频播放dom
  sliderWidth: 0, //进度条长度
  playSpeed: 1, //播放倍速
  shopStyle: '', //默认普通景区 pavilion：临展   buddhism：佛教寺庙

  set_playerShow(playerShow){
    this.playerShow = playerShow
  },
  set_currBag(currBag){
    this.currBag = currBag
  },
  set_playing(playing){
    this.playing = playing
  },
  set_playList(playList){
    this.playList = playList
  },
  set_currVoice(currVoice){
    this.currVoice = currVoice
  },
  set_currIndex(currIndex){
    this.currIndex = currIndex
  },
  set_currUrl(currUrl){
    this.currUrl = currUrl
  },
  set_currTime(currTime){
    this.currTime = currTime
  },
  set_sliderWidth(sliderWidth){
    this.sliderWidth = sliderWidth
  },
  set_playSpeed(playSpeed){
    this.playSpeed = playSpeed
  },
  set_shopStyle(shopStyle){
    this.shopStyle = shopStyle
  },

  set_glabalClear(){
    this.playerShow = false;
    this.currBag = {};
    this.playing = false;
    this.playList = [];
    this.currVoice = {};
    this.currIndex = -1;
    this.currUrl = '';
    this.sliderWidth = 0;
    this.playSpeed = 1;
    this.shopStyle = '';
    clearInterval(this.videoTimer);
    this.videoTimer = null;
    if (this.Audio1 && !this.Audio1.paused) {
      this.Audio1.pause();
    }
    this.Audio1 = null;
  }

};





// WEBPACK FOOTER //
// ./src/utils/glabal_song.js